import { injectGlobal } from 'styled-components';
import { DatePickerCSS } from './shared/css/styled';

/* eslint no-unused-expressions: 0 */
injectGlobal`
  html,
  body {
    height: 100%;
    width: 100%;
  }

  body {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  body.fontLoaded {
    font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  #app {
    min-height: 100%;
    min-width: 100%;
  }

  p,
  label {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    line-height: 1.5em;
  }
  ${DatePickerCSS}
  .ui.inverted.menu {
    background-color: #333d68!important;
  }

  /* Fix line-height for Semantic UI modal content so validation messages are not clipped */
  .ui.modal > .content {
    line-height: 2;
  }

  /* CUSTOM SPINNER TAKEN FORM SEMANTIC FORM */
  .loading.ramino {
    display: block;
  }
  .loading.ramino {
    position: relative;
    cursor: default;
    pointer-events: none;
  }
  .loading.ramino:before {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    background: rgba(255,255,255,.8);
    width: 100%;
    height: 100%;
    z-index: 100;
  }
  .loading.ramino:after {
    position: absolute;
    content: '';
    top: 50%;
    left: 50%;
    margin: -1.5em 0 0 -1.5em;
    width: 3em;
    height: 3em;
    -webkit-animation: form-spin .6s linear;
    animation: form-spin .6s linear;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    border-radius: 500rem;
    border-color: #767676 rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.1);
    border-style: solid;
    border-width: .2em;
    box-shadow: 0 0 0 1px transparent;
    visibility: visible;
    z-index: 101;
  }
  /* THIS IS THE END */

  /* Loader with padding removed for modal views */
  .loading.ramino.views:before {
    position: absolute;
    content: '';
    top: 0;
    left: -1.5rem;
    right: -1.5rem;
    background: rgba(255,255,255,.8);
    height: 100%;
    width: auto;
    z-index: 100;

  }

  .capitalize-first-letter:first-letter {
    text-transform: capitalize;
  }
  /* NOTA SBLOCCO ICON */
  .ui.mini.circular.icon.button.notaSbloccoFull {
    position: absolute;
    right: 0px;
    top: 18px;
    width: 18px;
    height: 18px;
    padding: 1px!important;
    paddingTop: 0px!important;
  }

  .loader-container {
    .ui.loader:after {
      border-color: #767676 transparent transparent !important;
    }
  }

  /* Disabled form fields styling */
  input:disabled,
  textarea:disabled {
    background-color: #f5f5f5 !important;
    color: rgba(0, 0, 0, 0.6) !important;
    border-color: rgba(34, 36, 38, 0.15) !important;
    cursor: not-allowed !important;
    opacity: 1 !important;
  }
`;



// WEBPACK FOOTER //
// ./app/global-styles.js